export const IconAnalyticsProzora20: {
  name: 'icon_analytics_prozora_20-4bb500877243'
} = {
  name: 'icon_analytics_prozora_20-4bb500877243'
}
